import { useSearchQueryFilter, useTrackEvents } from '@aibees/elephant/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, ButtonProps } from '@mui/material';
import { memo, useMemo } from 'react';
import { AddMoreFilter } from './components/add-more-filter';
import { EmployeeByDepartmentItem } from './components/employee-by-department-item';
import { INNER_SEPARATOR, ITEM_SEPARATOR } from './config';
import * as SX from './sx';
import type { EmployeeByDepartmentFilterProps as Props } from './types';
import { getItemsArray } from './utils';

export const EmployeeByDepartmentFilter = memo(
  ({ className, ...filter }: Props) => {
    const { params, setParam } = useSearchQueryFilter({
      select: [filter.field!],
    });
    const { track } = useTrackEvents();

    const itemsArray = useMemo(() => {
      return getItemsArray(params, filter.field!);
    }, [params, filter.field]);

    const handleClickAddMore: ButtonProps['onClick'] = () => {
      const p = params[filter.field!];
      if (!p) {
        const draft = INNER_SEPARATOR + ITEM_SEPARATOR + INNER_SEPARATOR;
        setParam(filter.field!, draft);
        track('FILTER', {
          values: draft,
          field: filter.field!,
        });
        return;
      }

      const draft = p + ITEM_SEPARATOR + INNER_SEPARATOR;
      setParam(filter.field!, draft);
      track('FILTER', {
        values: draft,
        field: filter.field!,
      });
    };

    return (
      <Box
        className={classnames('EmployeeByDepartmentFilter', className)}
        display="flex"
        flexDirection="column"
        gap={1}
        sx={SX.root}
      >
        {itemsArray.length === 0 ? (
          <EmployeeByDepartmentItem
            key={`${filter.field}-0-item`}
            field={filter.field!}
            index={0}
            items={filter.items ?? []}
          />
        ) : (
          itemsArray.map((_, index) => {
            return (
              <EmployeeByDepartmentItem
                key={`${filter.field}-${index}-item`}
                field={filter.field!}
                index={index}
                items={filter.items ?? []}
              />
            );
          })
        )}

        <AddMoreFilter onClick={handleClickAddMore} disabled={false} />
      </Box>
    );
  }
);

EmployeeByDepartmentFilter.displayName = 'EmployeeByDepartmentFilter';
